import React from 'react';
import PropTypes from 'prop-types';
import style from './style.css';
import Header from '../../components/Header';
import AppFooter from '../../components/AppFooter';

var AppDefs = window.cccisd.appDefs;
export default class MainLayout extends React.Component {
    static propTypes = {
        children: PropTypes.node,
        className: PropTypes.string,
    };

    static defaultProps = {
        className: 'container',
    };

    render() {
        // find the route for the current path
        const currentPath = window.location.pathname;
        const currentRoute = AppDefs.routes.find(route => route.url.startsWith(currentPath));
        let hideSecondaryNav = false;
        if (currentRoute && currentRoute.hideSecondaryNav) {
            hideSecondaryNav = true;
        }

        return (
            <div className={style.wrapper}>
                <Header className={this.props.className} hideSecondaryNav={hideSecondaryNav} />
                <div className={style.body}>
                    <div className={this.props.className}>{this.props.children}</div>
                </div>

                <AppFooter />
            </div>
        );
    }
}
